import React, { FC, useEffect, useState } from "react";
import { Input, Button } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const NumberInput: FC<{
  value?: number;
  onChange: any;
  placeholder?: string;
  disabled?: boolean;
}> = ({
  value,
  onChange,
  placeholder,
  disabled
}) => {
  const [val, setVal] = useState<any>(value|0);

  useEffect(()=>{
    if(value){
      setVal(value);
    }
  }, [value])

  return (
    <div className="d-flex custom-number">
      <Button className="beam-btn d-flex" disabled={disabled} onClick={() => {
        setVal(parseFloat(val)-1)
        onChange(parseFloat(val)-1)
        }}>
        <MinusOutlined />
      </Button>
      <Input  
        className="beam-input mx-2"
        placeholder={placeholder || 'Enter Number'}
        min="0"
        type="number"
        disabled={disabled}
        step="0.01"
        value={val}
        onWheel={(e: any) => e.target.blur()} 
        onChange={(e) => {
          setVal(e.target.value)
          onChange(e.target.value)
          }} />
      <Button className="beam-btn d-flex" disabled={disabled} onClick={() => {
        setVal(parseFloat(val)+1)
        onChange(parseFloat(val)+1)
        }}>
       <PlusOutlined />
      </Button>
    </div>
  );
};

export default NumberInput;
